module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-top": "20px",
      "margin-bottom": "20px"
    }
  }, [_c('h1', {
    staticClass: "u"
  }, [_vm._v("\n    Редактировать район\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "sub-nav"
  }, [_c('router-link', {
    staticClass: "btn btn-default btn-sm",
    attrs: {
      "to": {
        name: 'district-details',
        params: {
          district_id: _vm.district.id
        }
      }
    }
  }, [_vm._v("← Назад к Деталям района")])], 1), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [(_vm.district.id) ? _c('a', {
    staticClass: "red",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.deleteDistrict.apply(null, arguments)
      }
    }
  }, [_vm._v("удалить район")]) : _vm._e()]), _vm._v(" "), _c('district-edit-form', {
    attrs: {
      "district": _vm.district
    },
    on: {
      "after": _vm.handleAfter
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1c16a577","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/district/DistrictEdit.vue
// module id = 592
// module chunks = 0